import PaymentAPIintroduction from "../../PageComponents/PaymentAPIintroduction/PaymentAPIintroduction";
import QuickStart from "@/PageComponents/Quickstart/QuickStart";
import Faq from "@/PageComponents/FAQ/Index";
import Webhook from "@/PageComponents/FAQ/webhook/Index";
import MerchantAPPModeAPI from "../../PageComponents/MerchantAPPModeAPI";
// import MerchantUserWalletModeAPI from "../../PageComponents/MerchantUserWalletModeAPI";
import SupportHelp from "@/PageComponents/SupportHelp/Index";
import PublicResourceApi from "@/PageComponents/PublicResourceApi/Index";
// import SwapApi from "@/PageComponents/SwapApi/index";
import { useLocales } from "@/locales";
import { useEffect } from "react";
import MerchantUserWalletModeAPI from "@/PageComponents/MerchantUserWalletModeAPI";
// import UserSwapApi from "@/PageComponents/UserSwapApi";
// import SandboxMode from "../../PageComponents/SandboxMode";

export default function PageMap() {
  const { onChangeLang } = useLocales();
  useEffect(() => {
    const searchParams = window.location.search;

    if (searchParams) {
      let new_searchParams = searchParams.replace("?", "").replace("/", "");

      onChangeLang(new_searchParams);
    } else {
      onChangeLang("en");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div id="content-area">
      <PaymentAPIintroduction />
      <QuickStart />
      <Faq />
      <Webhook />
      <SupportHelp />
      <PublicResourceApi />
      <MerchantAPPModeAPI />
      {/* <SwapApi /> */}
      <MerchantUserWalletModeAPI />
      {/* <UserSwapApi /> */}
      {/* ------------------------------------ */}
      {/* <MerchantUserWalletModeAPI /> */}
      {/* <SandboxMode /> */}
    </div>
  );
}
